export class GpsDiagnosis {
  public hdop;
  public satellitesInView;
  public synchronismType;
  public isRunning;
  public gpsData;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/gps-diagnosis.ts